/** Flavor backgrounds change with selection while text stays dark. */
class PDPFlavorSection extends HTMLElement {
  connectedCallback() {
    this.defaultMode = this.dataset.colorMode;
    this.hoverCard = null;
    this.focusCard = null;
    this.carouselCard = null;
    this.events = new AbortController();
    const options = { signal: this.events.signal };

    this.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch') return;
      this.hoverCard = event.target.closest('.fyf-card');
      this.updateColors();
    }, options);
    this.addEventListener('pointerout', (event) => {
      if (event.pointerType === 'touch') return;
      this.hoverCard = this.cardWithinSection(event.relatedTarget);
      this.updateColors();
    }, options);
    this.addEventListener('focusin', (event) => {
      this.focusCard = event.target.closest('.fyf-card');
      this.updateColors();
    }, options);
    this.addEventListener('focusout', (event) => {
      this.focusCard = this.cardWithinSection(event.relatedTarget);
      this.updateColors();
    }, options);
    this.addEventListener('flavor:change', (event) => {
      this.carouselCard = event.detail.card;
      this.updateColors();
    }, options);
  }

  disconnectedCallback() {
    this.events.abort();
  }

  cardWithinSection(target) {
    return target instanceof Element && this.contains(target) ? target.closest('.fyf-card') : null;
  }

  updateColors() {
    const card = this.hoverCard || this.focusCard || this.carouselCard;
    if (card) {
      this.dataset.flavor = card.dataset.flavor;
      this.dataset.colorMode = 'accent-dark';
    } else {
      delete this.dataset.flavor;
      this.dataset.colorMode = this.defaultMode;
    }

  }
}

if (!customElements.get('pdp-flavor-section')) {
  customElements.define('pdp-flavor-section', PDPFlavorSection);
}
